function LiveVideo({ color }) {
    return (
        <svg width="25" height="25" fill={color} viewBox="0 0 24 24">
            <g fillRule="evenodd">
                <path
                    d="M467.029 161.014c-.363-.088-.746.014-1.048.234l-2.57 1.88a.999.999 0 00-.411.807v8.13a1 1 0 00.41.808l2.602 1.901a1.248 1.248 0 001.469.007c.34-.239.519-.65.519-1.065v-11.481a1.25 1.25 0 00-.971-1.22m-20.15 6.563c.1-.146 2.475-3.578 5.87-3.578 3.396 0 5.771 3.432 5.87 3.578a.749.749 0 010 .844c-.099.146-2.474 3.578-5.87 3.578-3.395 0-5.77-3.432-5.87-3.578a.749.749 0 010-.844zm10.871 9.922a3.754 3.754 0 003.75-3.75v-11.5a3.754 3.754 0 00-3.75-3.75h-10a3.754 3.754 0 00-3.75 3.75v11.5a3.754 3.754 0 003.75 3.75h10z"
                    transform="translate(-444 -156)"
                ></path>
                <path
                    d="M452.75 170.5c1.379 0 2.5-1.121 2.5-2.5s-1.121-2.5-2.5-2.5a2.503 2.503 0 00-2.5 2.5c0 1.379 1.121 2.5 2.5 2.5"
                    transform="translate(-444 -156)"
                ></path>
            </g>
        </svg>
    );
}

export default LiveVideo;
